// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @08.08.2019 07:18:41
import { PersistentObject } from '../../../SagaBase/PersistentObject';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class PhoneSession_abstract extends PersistentObject {
  static $t: string = 'SagaBase.Objects.PhoneSession';
  $t: string = 'SagaBase.Objects.PhoneSession';

  public static GetMembers(): string[] {
    return ['PhoneNumber', 'Token', 'PIN', 'ResResourceUId', 'Name', 'Validity'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return PhoneSession_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    this.Validity = this.Validity && new Date(this.Validity);

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public PhoneNumber: string;
  public Token: string;
  public PIN: string;
  public ResResourceUId: Guid = GuidTools.Empty;
  public Name: string;
  public Validity: Date = new Date();

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
